import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { styled } from '@mui/material/styles';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { PageButtons } from 'library/components/controls/buttons/PageButtons';
import { useLayoutStyle } from 'library/hooks/useLayoutStyle';
import { home_HomeUrl } from 'main/routes/urls/RouteUrls';

export interface ErrorContentProps extends PropsWithChildren {
	title: React.ReactNode;
	subtitle: React.ReactNode;
	description?: React.ReactNode;
	displayHomeButton?: boolean;
}

const StyledContainer = styled('div')({
	alignItems: 'center',
	display: 'flex',
	justifyContent: 'center',
	textAlign: 'center',
});

export const ErrorContent = ({
	children,
	title,
	subtitle,
	description,
	displayHomeButton = true,
}: ErrorContentProps): React.JSX.Element => {
	const { minHeight: height } = useLayoutStyle();
	const navigate = useNavigate();
	const { t } = useTranslation(['error', 'home']);

	return (
		<StyledContainer sx={{ minHeight: height, mb: -8 }}>
			<div className="alert alert-danger" role="alert">
				<ReportProblemIcon fontSize="large" />
				<h2 className="alert-heading">{title}</h2>
				<p>{subtitle}</p>
				{!!description && (
					<>
						<hr />
						<p className="mb-0">{description}</p>
					</>
				)}
				{children}

				{displayHomeButton && (
					<PageButtons
						primaryButtonLabel={t('home:root-title')}
						primaryButtonAction={() => {
							navigate(home_HomeUrl);
						}}
						withDivider={false}
					/>
				)}
			</div>
		</StyledContainer>
	);
};
